import colors, { palette } from './colors.mjs';

const keys = Object.keys;
const presetColorKeys = keys(colors);
const paletteColorKeys = keys(palette);
const presetGradientColorKeys = keys(palette.gradient);
const isPresetColor = (color) => {
  return !color.startsWith("currentColor") && !color.startsWith("rgba(") && !color.startsWith("rgb(") && !color.startsWith("hsla(") && !color.startsWith("hsl(") && !color.startsWith("#") && !color.startsWith("var(") && !color.startsWith("linear-gradient(");
};
const isPaletteKey = (color) => {
  return keys(palette).some((paletteKey) => paletteKey === color);
};
const isPresetGradientColor = (color) => {
  const gradientPalette = palette.gradient;
  return keys(gradientPalette).some((paletteKey) => paletteKey === color);
};

export { isPaletteKey, isPresetColor, isPresetGradientColor, paletteColorKeys, presetColorKeys, presetGradientColorKeys };
//# sourceMappingURL=presetColor.mjs.map
